import * as React from 'react';
import { usePlannerContext } from '../../Planner/Context/PlannerContextProvider';
import { usePlannerTranslations } from '../../Planner/Context/PlannerTranslationsContextProvider';
import { FormattedText } from '~/Features/Txt/TxtBase';
import { Button } from '~/Partials/Button/Button';
import { ButtonSize } from '~/Partials/Button/ButtonSize.csharp';
import { ButtonTier } from '~/Partials/Button/ButtonTier.csharp';
import { ButtonType } from '~/Partials/Button/ButtonType.csharp';
import { moneyToString } from '~/Partials/Utils/utils';
import styles from './SummaryFooter.module.css';

export interface SummaryFooterAction {
    label: string;
    onClick: () => void;
    isDisabled?: boolean;
}

export interface SummaryFooterProps {
    action: SummaryFooterAction;
}

export const SummaryFooter: React.FC<SummaryFooterProps> = props => {
    const { action } = props;
    const { totalPoints, totalPrice } = usePlannerContext();
    const { description, creditsLabel } = usePlannerTranslations();
    const { totalCreditsFormat } = description;

    return (
        <div className={styles.SummaryFooter}>
            <div className={styles.Total}>
                <span className={styles.TotalPoints}>
                    {FormattedText(totalCreditsFormat, {
                        credits: totalPoints,
                        creditsName: creditsLabel,
                    })}
                </span>
                <span className={styles.TotalPrice}>{moneyToString(totalPrice)}</span>
            </div>
            <Button
                type={ButtonType.Solid}
                tier={ButtonTier.Secondary}
                size={ButtonSize.ResponsiveFromMediumToLarge}
                disabled={action.isDisabled}
                onClick={action.onClick}
            >
                {action.label}
            </Button>
        </div>
    );
};
